var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.95,
    height: 25.477,
    viewBox: "0 0 20.95 25.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50095",
    "data-name": "Group 50095",
    transform: "translate(-8047.75 -15970.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93914",
    "data-name": "Path 93914",
    d: "M315.7,29.29c0,.15-.02.3-.02.45V44.18a2.687,2.687,0,0,0,1.16,2.32c1.21.76,2.71.44,4.05.39,1.68-.06,3.35-.1,5.03-.11,1.19,0,2.38,0,3.58.03a1.9,1.9,0,0,0,1.48-.55,2.625,2.625,0,0,0,.74-1.39,2.5,2.5,0,0,0,.04-.55V29.29",
    transform: "translate(7734.5 15948.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93915",
    "data-name": "Path 93915",
    d: "M320.219,31.68q-.06,6,0,12",
    transform: "translate(7734.5 15948.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93916",
    "data-name": "Path 93916",
    d: "M323.7,31.68q.06,6,0,12",
    transform: "translate(7734.5 15948.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93917",
    "data-name": "Path 93917",
    d: "M327.23,31.68v12",
    transform: "translate(7734.5 15948.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93918",
    "data-name": "Path 93918",
    d: "M331.64,25.65H315.81a1.805,1.805,0,1,0,0,3.61h15.83a1.805,1.805,0,1,0,0-3.61Z",
    transform: "translate(7734.5 15948.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93919",
    "data-name": "Path 93919",
    d: "M319.32,25.64A2.621,2.621,0,0,1,321.8,23h3.84a2.48,2.48,0,0,1,2.48,2.48v.09",
    transform: "translate(7734.5 15948.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDelete);
export default __webpack_public_path__ + "static/media/white-delete.ff1ae36d3c7f417e3de5af086a4c0a56.svg";
export { ForwardRef as ReactComponent };